module.exports = __webpack_public_path__ + "static/media/No_TimeLog_Report.9aa1ff56.svg";